import { Form, message } from "antd";
import * as React from "react";
import ResetPassword from "../../presentation/resetPassword";
import { RestApplicationClient } from "../../../core/services/D3AdminServices";
import { ROUTES } from "../../../core/models/enums/routes";
import { Navigate, useNavigate } from "react-router-dom";
import { storageService } from "../../../core/services/Storage.service";
import { LOGIN_CONSTANT_TO_CHECK, USERS, USER_ROLE } from "../../../core/models/constants/Core.Constants";

type ResetPasswordContainerProps = {
  //
};

const ResetPasswordContainer: React.FC<ResetPasswordContainerProps> = () => {
  let restApplication = RestApplicationClient();
  const [resetPasswordForm] = Form.useForm();
  const navigate = useNavigate();

  const allowed = sessionStorage.getItem("allowResetOnce") === "1";
  if (allowed) {
    sessionStorage.removeItem("allowResetOnce");
  }

  if (!allowed) {
    localStorage.removeItem("token");
    localStorage.removeItem(LOGIN_CONSTANT_TO_CHECK);
    localStorage.removeItem(USER_ROLE);
    sessionStorage.clear();

    return <Navigate to={ROUTES.LOGIN} replace />;
  }


  const changePassword = () => {
    let loginRequest = resetPasswordForm.getFieldsValue();
    restApplication.changePassword({ userName: loginRequest.userName, oldPassword: loginRequest.oldPassword, newPassword: loginRequest.newPassword })
      .then((response: any) => {
        if (response.responseCode === 200) {
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            resetPasswordForm.resetFields();
            navigate(ROUTES.LOGIN);
          }, 3000);
          return message.success(response.message);
        } else if (response.errorCode === 150) {
          return message.error(response.errors[0])
        } else {
          return message.error(response.errorMsg)
        }
      })
      .catch((error) => {
        console.log(error);
        resetPasswordForm.resetFields()
        return message.error(error.message)
      })
  }

  return (
    <div>
      <ResetPassword
        resetPasswordForm={resetPasswordForm}
        changePassword={changePassword}
      />
    </div>
  );
};

export default ResetPasswordContainer;
